"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const TiktokIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M10.734 1c.23 1.987 1.34 3.171 3.266 3.297v2.235c-1.117.109-2.095-.257-3.233-.945v4.179c0 5.309-5.785 6.968-8.11 3.162-1.495-2.448-.58-6.745 4.215-6.917v2.356a6.933 6.933 0 00-1.113.273c-1.066.361-1.67 1.037-1.503 2.23.323 2.285 4.513 2.961 4.165-1.503V1.004h2.313V1z",
    clipRule: "evenodd"
  })))
});
TiktokIcon.displayName = 'TiktokIcon';
var _default = exports.default = TiktokIcon;